import React from 'react';
import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import { onlyInteger } from 'hooks/Pipe';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

//reemplazando valores de iniciales en estado

export default function ModalConcept(props) {
  const concept = props.model;

  return (
    <Modal
      title="Concepto"
      model={concept}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      entity="purch/concept"
    >
      <TextField
        label="Descripción"
        type="text"
        name="description"
        margin="normal"
        fullWidth
        defaultValue={!!concept ? concept.description : ''}
        required
      />
      <FormControl fullWidth margin="normal" size="small">
        <InputLabel>Tipo</InputLabel>
        <Select
          required
          defaultValue={!!concept ? concept.type : ''}
          inputProps={{
            name: 'type',
          }}
        >
          <MenuItem value="T">Todos</MenuItem>
          <MenuItem value="C">Crédito</MenuItem>
          <MenuItem value="D">Débito</MenuItem>
        </Select>
      </FormControl>
      <TextField
        label="Cuenta"
        type="text"
        name="Account"
        margin="normal"
        fullWidth
        defaultValue={!!concept ? concept.Account : ''}
        // disabled={concept.Account}
        onKeyPress={onlyInteger}
        required
      />
    </Modal>
  );
}
